import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

const rolePermissions: Record<string, string[]> = {
  super_admin: [
    'dashboard', 'users', 'kyc', 'merchants', 'transactions', 'activity-log', 'customer-service', 'settings'
  ],
  kyc_officer: [
    'dashboard', 'users', 'kyc', 'customer-service'
  ],
  customer_support: [
    'dashboard', 'users', 'transactions', 'customer-service'
  ],
  compliance_officer: [
    'dashboard', 'users', 'kyc', 'transactions', 'activity-log'
  ],
  merchant_manager: [
    'dashboard', 'merchants', 'transactions'
  ],
  auditor: [
    'dashboard', 'users', 'merchants', 'transactions', 'activity-log'
  ],
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermission }) => {
  const { isAuthenticated, employee } = useAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (requiredPermission) {
    const userRole = employee?.role || '';
    const hasPermission = userRole === 'super_admin' || rolePermissions[userRole]?.includes(requiredPermission);
    
    if (!hasPermission) {
      return <Navigate to="/" replace />;
    }
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
